@if (useSplitCardsDesign()) {
  @if (email()) {
    <mwe-basic-card
      iconClass="fas fa-file-user mr-1"
      [cardTitle]="personalDataTitle()"
      [hasBackground]="true"
      [headingNodeType]="headingNodeType()"
      data-test="products-summary-personalData"
    >
      <ng-container [ngTemplateOutlet]="personalData"></ng-container>
    </mwe-basic-card>
  }

  @if (contractInfos()?.length) {
    <mwe-basic-card
      iconClass="fas fa-file-lines mr-1"
      cardClass="mt-4"
      [cardTitle]="cardTitle()"
      [hasBackground]="true"
      [headingNodeType]="headingNodeType()"
      data-test="products-summary-personalBilling"
    >
      <ng-container [ngTemplateOutlet]="contractData"></ng-container>
    </mwe-basic-card>
  }

  <mwe-basic-card
    iconClass="fas fa-envelope-open-text mr-1"
    cardClass="mt-4"
    [cardTitle]="billingCardTitle()"
    [hasBackground]="true"
    [headingNodeType]="headingNodeType()"
    data-test="products-summary-personalBilling-paymentData"
  >
    <ng-container [ngTemplateOutlet]="billingData"></ng-container>
  </mwe-basic-card>
} @else {
  <mwe-basic-card
    iconClass="fas mr-1 {{ singleCardIcon() }}"
    [cardTitle]="cardTitle()"
    [hasBackground]="true"
    [headingNodeType]="headingNodeType()"
    data-test="products-summary-personalData"
  >
    @if (email()) {
      <ng-container [ngTemplateOutlet]="personalData"></ng-container>
    }
    @if (email() && contractInfos()?.length) {
      <hr />
    }
    @if (contractInfos()?.length) {
      <ng-container [ngTemplateOutlet]="contractData"></ng-container>
      <hr />
    }
    <ng-container [ngTemplateOutlet]="billingData"></ng-container>
  </mwe-basic-card>
}

<ng-template #personalData>
  <div data-test="products-summary-personalData-email">
    @if (!useSplitCardsDesign()) {
      <mwe-headline
        data-test="products-summary-personalData-email-headline"
        cssClass="font-size-16 lh-base fw-semibold text-secondary mb-2"
        text="summary.invoiceCard.customerData.title"
        [headlineNodeType]="headingNodeType()"
      />
    }
    <strong class="d-inline-block mb-3">
      <span>{{ 'summary.invoiceCard.customerData.email' | translate }}</span
      >:
    </strong>
    {{ email() }}
    @if (emailMessageInfoKey()) {
      <mwe-infobox [messageKey]="emailMessageInfoKey()" [textParams]="{ email: email() }" />
    }
  </div>
</ng-template>

<ng-template #contractData>
  @for (contractInfo of contractInfos(); track contractInfo) {
    @if (!$first) {
      <hr />
    }
    <mwe-product-summary-contract-info [contractInfos]="contractInfo" />
  }
</ng-template>

<ng-template #billingData>
  <div data-test="products-summary-personalBilling-payment">
    <mwe-headline
      cssClass="font-size-16 lh-base fw-semibold text-secondary mb-2"
      text="summary.paymentData"
      [headlineNodeType]="headingNodeType()"
    />

    <div class="row align-items-center g-2">
      <div class="col col-auto">
        <div class="payment-badge">
          <img class="img-fluid" src="/assets/icons/payment/{{ paymentIcon() }}.svg" [alt]="paymentIcon()" />
        </div>
      </div>
      <div class="col">
        <p class="mb-0" [innerHTML]="paymentText()"></p>
      </div>
    </div>

    @if (paymentInfo()) {
      <mwe-infobox [messageKey]="paymentInfo()" class="d-block mt-3" />
    }
  </div>
  <hr />
  <div data-test="products-summary-personalBilling-eBilling">
    <mwe-headline
      cssClass="font-size-16 lh-base fw-semibold text-secondary mb-2"
      text="summary.invoiceShipping"
      [headlineNodeType]="headingNodeType()"
    />

    @if (eRechnungInfo()?.isERechnungsEmpfaenger) {
      <p [innerHTML]="'summary.invoiceAddress.method.email' | translate | safeHtml" class="mb-1"></p>
      <p class="mb-1" data-test="products-summary-personalBilling-email">
        <b>{{ 'summary.invoiceAddress.method.emailAddress' | translate }}</b> {{ eRechnungInfo().rechnungEmail }}
      </p>
    } @else {
      <p [innerHTML]="'summary.invoiceAddress.method.post' | translate | safeHtml" class="mb-1"></p>
    }

    <p class="mb-0">
      <b
        ><span>{{ 'summary.eBilling' | translate }}</span
        >:
      </b>
      <span data-test="products-summary-personalBilling-invoice-address"> {{ formattedInvoiceAddress() }}</span>
    </p>
  </div>

  @if (additionalBulletPoints().length) {
    <ul class="list-separated spacing-4 mt-5">
      @for (point of additionalBulletPoints(); track $index) {
        <li [attr.data-test]="point.id">
          <mwe-headline cssClass="font-size-16 lh-base" [text]="point.title" [headlineNodeType]="headingNodeType()" />

          <p class="text--big mb-0">{{ point.text | translate }}</p>
        </li>
      }
    </ul>
  }

  @if (areBankAccountInfoTextsVisible() && !showBankAccountInfoTextAsAlert()) {
    <div class="mt-3">
      <mwe-new-bank-account-info-texts useTemplate="alert" [hasSpotTariff]="hasSpotTariff()" [productCategories]="productCategories()" />
    </div>
  }
</ng-template>

@if (invoiceInfoAlertMessage()) {
  <mwe-infobox [messageKey]="invoiceInfoAlertMessage()" class="d-block mt-4" data-test="products-summary-personalBilling-eBillingAlert" />
}

@if (areBankAccountInfoTextsVisible() && showBankAccountInfoTextAsAlert()) {
  <div class="mt-4 mb-4">
    <mwe-new-bank-account-info-texts [hasSpotTariff]="hasSpotTariff()" [productCategories]="productCategories()" />
  </div>
}
